import BasicTextInput from "components/BasicInputs/BasicTextInput";
import ContainedTabs from "components/Tabs/Tabs3";
import {useEffect, useState} from "react";

export interface SwitchableTextInputProps extends BasicTextInputProps {
}

export default function SwitchableTextInput(props: SwitchableTextInputProps) {
    const [active, setActive] = useState<number>(0);
    const [val, setVal] = useState(props?.val);

    useEffect(() => {
        props.onChange && props.onChange(active && val ? val : 0);
    }, [active, val]);

    const tabs = (
        <div>
            <ContainedTabs
                tabs={[
                    {label: "اتوماتیک", activeColor: "#1062D0"},
                    {label: "دستی", activeColor: "#CB0B0B"},
                ]}
                centered={true}
                onChange={(val) => val !== undefined && setActive(val)}
                size={3}
                minWidth={46}
            />
        </div>
    );
    return (
        <>
            <BasicTextInput {...props} actionSection={tabs} disabled={active === 0} onChange={(x) => setVal(x)}/>
        </>
    );
}
